import { render, staticRenderFns } from "./MaotSection.vue?vue&type=template&id=c42851dc&scoped=true"
import script from "./MaotSection.vue?vue&type=script&lang=js"
export * from "./MaotSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42851dc",
  null
  
)

export default component.exports